  <template >
  <div v-if="show" ref="crossword" class="crossword">
    <div class="background" :style="`width: ${heightCell * (matrix[0].length)}px;
     height: ${heightCell * (matrix.length)}px !important`" >
           <template v-if="matrix[0].length > 0">

      <span
        v-for='(y, column) in matrix[0].length'
        :key='y'
        class='column'
      >
          <span
          @click='(e) => { if(matrix[row][column].palavra_horizontal > 0 || matrix[row][column].palavra_vertical > 0) if(!finished) selectCellsOfWord(matrix[row][column], e) }'
          :class="matrix[row][column].palavra_horizontal < 0 && matrix[row][column].palavra_vertical < 0 ? 'celula death' : 'celula'"
          v-for='(x, row) in matrix.length'
          :style="`width: ${heightCell}px; height: ${heightCell}px`"
          :id='`row${row}column${column}`'
          :key='x'
        >

        <template v-if="type === 3 && matrix[row][column].palavra_1 != -1 || matrix[row][column].palavra_2">


            <span :class="`x-type3 ${matrix[row][column].palavra_2 == -1 ? 'index-type3-center':''}`" v-if="matrix[row][column].palavra_1 !== -1">{{matrix[row][column].palavra_1.indice}}</span>
            <span :class="`y-type3 ${matrix[row][column].palavra_1 == -1 ? 'index-type3-center':''}`" v-if="matrix[row][column].palavra_2 !== -1">{{matrix[row][column].palavra_2.indice}}</span>

            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'arrow_right')" :class="`fa fa-caret-right arrow_right`"></i>
            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'arrow_down')" :class="`fa fa-caret-down arrow_down`"></i>
            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'curved_arrow_left')" :class="`fa fa-caret-down curved_arrow_left`"></i>
            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'curved_arrow_bottom')" :class="`fa fa-caret-right curved_arrow_bottom`"></i>
            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'arrow_bottom_lado')" :class="`fa fa-caret-down arrow_bottom_lado`"></i>
            <i v-if="validatorArrow(getClassArrowPosition(matrix[row][column], row, column), 'arrow_left_cima')" :class="`fa fa-caret-right arrow_left_cima`"></i>
        </template>
        <template v-else>
          <a class="x" v-if="column == 0">{{x}}</a>
          <a class="y" v-if="row == 0">{{y}}</a>
        </template>

          <span
            v-if='matrix[row][column].palavra_horizontal > 0 || matrix[row][column].palavra_vertical > 0'
            class='letter'
          >{{matrix[row][column].letra}}</span>

        
        </span>

      </span>
            </template>

      <br/>
    </div>
    </div>
</template>
<script>
import Crossword from './crossword'
export default {
  name: 'CrossWord',
  mixins: [Crossword],
  data: () => ({
    show: false,
  }),
  async mounted(){
    if(this.matrix[0].length > 0){
      this.show = true
    }
  }
}
</script>
<style scoped>

.selected_cell{
  border: solid 2px #4b4b4b !important;
  animation: letterSize 1s infinite;
  font-size: 15px;
}

.keys-selector i{
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5em;
  cursor: pointer;
}

.keys-selector{
  width: 100%;
  padding: 10px 20px;
  background-color: white;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.171);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1em;
}

.keys {
    padding-top: 20px;
    margin-top: -4px;
    background: #ffffff;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 0px 0px 10px 10px;
    font-family: 'Roboto', sans-serif;
    color: black;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.315);
  }

  a{
    text-decoration: none;
    color: black;
    pointer-events: none;
  }

  .options{
    border-top: solid 1px rgba(0, 0, 0, 0.137);
    margin-top: 15px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 5px 0px;
  }

  .mb-3{
    margin-bottom: 15px;
  }
  .options span i {
    color: #7c5491;
  }

  .d-flex{
    display: flex !important;
  }

  .options span{
    background-color: rgba(252,176,69,1);
    color: black;
    border-radius: 60px;
    font-size: 13px;
    padding: 5px 20px;
    margin: 10px 20px;
    cursor: pointer;

  }

  .justify-content-center{
    display: flex;
    justify-content: center;
  }

  .relative{
    position: relative;
    width: 100%;
  }

  .key{
    font-size: .9rem;
    animation: ease 5s;
  }
  
  .crossword{
    border-radius: 5px;
  }

  

  .key:hover{
    font-size: 0.95rem;
  }
  
  .keys .fa-angle-left{
    position: absolute;
    left: 25px;
    top: calc(50% - 15px);
    cursor: pointer;
    font-size: 30px;
  }
  
  .keys .fa-angle-right{
    position: absolute;
    right: 25px;
    font-size: 30px;
    top: calc(50% - 15px);
      cursor: pointer;
  
  }
  
  .keys i{
    color: rgba(0, 0, 0, 0.384);
    opacity: .9;
  }

  .w-75{
    width: 70% !important; 
  }
  
  .text-center{
    text-align: center;
  }
  .celula {
    box-sizing: border-box;
    border: solid 1px rgba(131, 58, 180, 0.419);
    background-color: white;
    display: block;
    justify-content: center;
    align-items: center;
    font-family: 'Roboto', sans-serif;
    color: black;
    position: relative;
  }

  .celula .x{
    position: absolute;
    top: 50%;
    left: 0%;
    transform: translate(-150%, -50%);
    text-align: right;
    font-size: .7em;
  }

 
  .celula .y{
    position: absolute;
    text-align: center;
    font-size: .7em;
    top: 0%;
    left: 50%;
    transform: translate(-50%, -110%);
  }

   .celula .x-type3{
    position: absolute;
    top: 0px;
    right: 5px;
        font-size: 12px;

  }

  .celula .y-type3{
    position: absolute;
    bottom: 0px;
    font-size: 12px;
    left: 5px;
  }

  .index-type3-center{
    position: absolute;
    left: calc(50% - 5px) !important;
    top: calc(50% - 12px) !important;
  }

.arrow_down{
  position: absolute;
  left: 50%;
  bottom: 6px;
  font-size: 20px;
  transform: translate(-50%, 100%);
  z-index: 99;
}

.curved_arrow_left{
  position: absolute;
  left: 100%;
  top: 0%;
  font-size: 20px;
  transform: translate(180%, -40%);
  z-index: 99;
}

.curved_arrow_bottom{
  position: absolute;
  left: 0%;
  bottom: 0%;
  font-size: 20px;
  transform: translate(-0%, 180%);
  z-index: 99;
}

.arrow_right{
  position: absolute;
  right: 0%;
  top: 50%;
  font-size: 20px;
  transform: translate(100%, -52%);
  z-index: 99;
}

.arrow_bottom_lado{
  position: absolute;
  left: -55%;
  top: 0%;
    transform: translate(-50%, -40%);

  font-size: 20px;
  z-index: 99;
}

.arrow_left_cima{
position: absolute;
  left: 0%;
  top: -50%;
    transform: translate(0%, -50%);

  font-size: 20px;
  z-index: 99;
}
  
  .select {
    background-color: #c0c0c0 !important;
  }
  
  .letter {
    position: absolute;
    pointer-events: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-transform: uppercase;
    font-weight: 100;
    z-index: 999 !important;
  }

  @keyframes letterSize {
  0%   {font-size: 15px !important;}
  50%  {font-size: 25px !important;}
  100% {font-size: 15px !important;}
}
  
  .column {
    display: inline-block;
  }
  
  .death {
    background-color: transparent;
  
  }

  .background{
    background: rgb(131,58,180);
    background: linear-gradient(90deg, #815c8f 0%, #5b8c6e 100%);
  }

  .correct{
    background-color: #3dc471;
    color: white;
  }

  .incorrect{
    background-color: #c43d3d !important;
    color: white;
  }
</style>
